module.exports = {
  RUN_AUTOPLAY: 'RUN_AUTOPLAY',
  SET_AUTOPLAY: 'SET_AUTOPLAY',
  SET_SPINS: 'SET_SPINS',
  STOP_AUTOPLAY: 'STOP_AUTOPLAY',
  UPDATE_AUTOPLAY: 'UPDATE_AUTOPLAY',
  SET_BALANCE: 'SET_BALANCE',
  UPDATE_AUTOPLAY_BALANCE: 'UPDATE_AUTOPLAY_BALANCE',
  DISABLE_AUTOPLAY: 'DISABLE_AUTOPLAY',
  AUTOPLAY_DONE: 'AUTOPLAY_DONE',
}
